// extracted by mini-css-extract-plugin
export default {"back-button":"backbutton_back-button__wcmqv"};